import React, { Component } from "react";
import { Grid, Button, Typography, Hidden, TextField } from "@material-ui/core";
import {
  CarouselProvider,
  Slider,
  Slide,
  ButtonBack,
  ButtonNext,
} from "pure-react-carousel";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { MuiThemeProvider } from "@material-ui/core/styles";
import { theme } from "../theme";
import "pure-react-carousel/dist/react-carousel.es.css";
import axios from "axios";
// Assets
// import "./landingpage.css";
import aura from "../../assets/aura.png";
import shortfilm from "../../assets/from-indu.jpg";
import streetplay from "../../assets/streetplay.jpg";
import team1 from "../../assets/team1.jpg";
import team2 from "../../assets/team2.jpg";
import team3 from "../../assets/team3.jpg";
import team4 from "../../assets/team4.jpg";
import team5 from "../../assets/team5.jpg";
import {Helmet} from "react-helmet";

export class LandingPage extends Component {
  constructor(props) {
    super();
    this.state = {
      name: "",
      mess: "",
      email: "",
      error: "",
      display: "",
      fullNameError: false,
      emailError: false,
      messageError: false,
    };
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount=()=>{
    
  }

  handleChange = (value) => (e) => {
    this.setState({
      [value]: e.target.value,
    });
  };

  validate = () => {
    const { name, email, mess } = this.state;
    let fullNameError = false;
    let emailError = false;
    let messageError = false;
    let regex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/

    this.setState({
      fullNameError,
      emailError,
      messageError,
    });
    if (name.trim() === "") {
      fullNameError = true;
    }
    if (email.trim() === "" || !regex.test(email)) {
      emailError = true;
    }
    if (mess.trim() === "") {
      messageError = true;
    }
    this.setState({
      fullNameError,
      emailError,
      messageError,
    });
    if (fullNameError || emailError || messageError) {
      return false;
    }
    return true;
  };

  handleSubmit = () => {
    const val = this.validate();
    const { name, email, mess } = this.state;

    if (val) {
      var bodyFormData = new FormData();
      bodyFormData.set("name", name);
      bodyFormData.append("email", email);
      bodyFormData.append("mess", mess);
      axios({
        method: "post",
        url: "https://djaura.pythonanywhere.com/",
        data: bodyFormData,
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then(function (response) {
        })
        .catch(function (response) {
        });
      document.getElementById("display").style.display = "none ";
      document.getElementById("form").style.display = "none";
      document.getElementById("thankYou").style.display = "block";
    }
  };

  display = () => {
    document.getElementById("form").style.display = "block";
    document.getElementById("thankYou").style.display = "none";
    this.setState({
      display: "initial",
      name: "",
      mess: "",
      email: "",
    });
  };

  thankYou = () => (
    <React.Fragment>
      <br />
      <Typography
        variant="h5"
        component="p"
        id="contact-us"
        style={{ fontSize: "2rem" }}
      >
        Thanks for reaching out to us!
      </Typography>
      <br />
      <br />
      <br />
      <Button
        size="large"
        variant="contained"
        color="primary"
        fullWidth
        style={{ color: "white", backgroundColor: "#fec007" }}
        onClick={this.display}
      >
        Send another message
      </Button>
    </React.Fragment>
  );

  render() {
    return (
      <MuiThemeProvider theme={theme}>
         <Helmet>
          <title>DJSCE Aura</title>
          <meta
            name="description"
            content="Official website of the dramatics club of DJ Sanghvi College Of Engineering."
          />
        </Helmet>
        <div>
          <div
            className="content-wrapper fadeInUp"
            style={{ animationDelay: "0.5s", padding: "0 40px 40px 40px" }}
            id="rootPageHero"
          >
            <Hidden only={["xs","sm"]}>
            <img id="largeimg" alt='aura' src={aura} />
            </Hidden>
            <Hidden only={["md", "lg", "xl"]}>
            <img id="smallimg" alt='aura-sm' src={aura} />
              </Hidden>
            <Hidden only={["xs"]}>
            
              <h3 id="heroSubText">
                Team Aura is the dramatics team of Dwarkadas J Sanghvi College
                Of Engineering, Mumbai. We are a team of engineering
                undergraduates, passionate about the theatrical arts.
              </h3>
            </Hidden>
            <Hidden only={["sm", "md", "lg", "xl"]}>
              <h3 id="heroSubText-sm">
                Team Aura is the dramatics team of Dwarkadas J Sanghvi College
                Of Engineering, Mumbai. We are a team of engineering
                undergraduates, passionate about the theatrical arts.
              </h3>
            </Hidden>
          </div>
          <div
            className="content-wrapper fadeInUp"
            id="work"
            style={{ animationDelay: "0.8s" }}
          >
            <br />
            <Link to="/" className="linkToWork">
              <Typography className="align-center section-title" variant="h3">
                Our Team
              </Typography>
            </Link>
            <Grid item xs={12} className="content-wrapper">
              <CarouselProvider
                naturalSlideWidth={100}
                naturalSlideHeight={50}
                totalSlides={5}
              >
                <Link to="/blogs" className="linkToWork">
                  <Slider>
                    <Slide className="slide" index={0}>
                      <img alt='team1' src={team1} />
                    </Slide>
                    <Slide className="slide" index={1}>
                      <img alt='team2' src={team2} />
                    </Slide>
                    <Slide className="slide" index={2}>
                      <img alt='team3' src={team3} />
                    </Slide>
                    <Slide className="slide" index={3}>
                      <img alt='team4' src={team4} />
                    </Slide>
                    <Slide className="slide" index={4}>
                      <img alt='team5' src={team5} />
                    </Slide>
                  </Slider>
                </Link>
                <ButtonBack className="sliderbutton">
                  <FontAwesomeIcon
                    className="star"
                    color="gray"
                    icon={faChevronLeft}
                  />
                </ButtonBack>
                <ButtonNext className="sliderbutton">
                  <FontAwesomeIcon
                    className="star"
                    color="gray"
                    icon={faChevronRight}
                  />
                </ButtonNext>
              </CarouselProvider>
            </Grid>
          </div>
          <div
            className="content-wrapper fadeInUp"
            id="work"
            style={{ animationDelay: "0.8s" }}
          >
            <br />
            <Typography className="align-center section-title" variant="h3">
              Our work
            </Typography>
            <Grid container>
              <Link
                to="/work"
                className="linkToWork"
                onClick={() => this.props.getType("streetplay")}
              >
                <Grid item xs={12} md={6} style={{ padding: "10px" }}>
                  <br />
                  <br />
                  <div className="align-center">
                    <Typography
                      variant="h5"
                      className="work-name"
                      // href={practiceFormPath}
                    >
                      Streetplays
                    </Typography>
                    <div className="imgDiv">
                      <img alt='streetplay' className="work-icon" src={streetplay} />
                    </div>

                    <Typography variant="h6" className="work-description">
                      Team Aura has been performing street plays since its
                      inception. We participate and perform at various fests in
                      colleges across Mumbai. Addressing social causes and
                      voicing the suppressed has always been our motto for
                      developing street plays. We believe in ‘empowerment
                      through art’. Currently one of the most esteemed street
                      play teams in the Mumbai zonal circuit, we are looking
                      forward to expanding our horizons.
                    </Typography>
                  </div>
                </Grid>
              </Link>
              <Link
                to="/work"
                className="linkToWork"
                onClick={() => this.props.getType("shortfilm")}
              >
                <Grid item xs={12} md={6} style={{ padding: "10px" }}>
                  <br />
                  <br />
                  <div className="align-center">
                    <Typography variant="h5" className="work-name">
                      Short Films
                    </Typography>
                    <div className="imgDiv">
                      <img alt='shortfilm' className="work-icon" src={shortfilm} />
                    </div>
                    <Typography variant="h6" className="work-description">
                    Our short films are amateur cinematography projects, which have been appreciated entries to major short film contests. These films are musings of our creativity,
                     unbound by genre and plot. They are a medium for us amatuer film-makers to nourish our fantasies of beautiful shots, mind-blowing stories and performing on reel.
                    </Typography>
                  </div>
                </Grid>
              </Link>
            </Grid>
          </div>
          <div
            className="content-wrapper fadeInUp"
            style={{ animationDelay: "0.7s" }}
            id="contact"
          >
            <div
              id="inquiry"
              className="center content-wrapper"
              style={{ padding: "10px" }}
            >
              <Typography className="align-center section-title" variant="h3">
                Contact us
              </Typography>
              <Grid container>
                <Grid item xs={12} md={6} style={{ color: "gray" }}>
                  <br />
                  <Typography variant="h5" component="p" id="contact-us">
                    <b>
                      E-mail:
                      <br />
                      <a
                        href="mailto:someone@example.com"
                        style={{ textDecoration: "none", color: "white" }}
                      >
                        djsceaura@gmail.com
                      </a>
                    </b>
                  </Typography>
                  <br />
                  {/* <Typography variant="h5" component="p" id="contact-us">
                    <b>
                      Address:
                      <br />
                      No U-15, J.V.P.D Scheme
                      <br />
                      Bhaktivedanata Swami Marg
                      <br />
                      Vile Parle (W), Mumbai
                      <br />
                      400053
                    </b>
                  </Typography> */}
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3770.012422442546!2d72.83491871531346!3d19.107110955958117!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c9c676018b43%3A0x75f29a4205098f99!2sDwarkadas%20Jivanlal%20Sanghvi%20College%20of%20Engineering!5e0!3m2!1sen!2sin!4v1616078057972!5m2!1sen!2sin"
                    width="300"
                    id="g-map"
                    height="300"
                    style={{ border: "0" }}
                    loading="lazy"
                    title='map'
                  ></iframe>
                </Grid>

                <Grid item xs={12} md={1} />
                <Grid item xs={12} md={5} id="form">
                  <form id="resetform">
                    <TextField
                      label="Full Name"
                      value={this.state.name}
                      placeholder="e.g. John Smith"
                      onChange={this.handleChange("name")}
                      margin="normal"
                      fullWidth
                      variant="outlined"
                      className="seemless-textfield1"
                      InputLabelProps={{ shrink: true}}
                      // inputProps={{ style: { fontFamily: 'nunito', backgroundColor: 'whitesmoke',color:'white'}}}
                      error={this.state.fullNameError}
                    />
                    {this.state.fullNameError ? (
                      <Typography className="error-message" variant="body2">
                        *Please provide your full name
                      </Typography>
                    ) : (
                      ""
                    )}
                    {/* <br /> */}
                    <TextField
                      label="Email"
                      value={this.state.email}
                      placeholder="e.g. johnsmith@mail.com"
                      onChange={this.handleChange("email")}
                      margin="normal"
                      fullWidth
                      variant="outlined"
                      className="seemless-textfield1"
                      InputLabelProps={{ shrink: true }}
                      error={this.state.emailError}
                    />
                    {this.state.emailError ? (
                      <Typography className="error-message" variant="body2">
                        *Please provide valid email
                      </Typography>
                    ) : (
                      ""
                    )}
                    {/* <br /> */}
                    <TextField
                      label="Message"
                      value={this.state.mess}
                      placeholder="Feedback, questions, suggestions? We're here for you!"
                      onChange={this.handleChange("mess")}
                      multiline
                      fullWidth
                      rows="4"
                      variant="outlined"
                      margin="normal"
                      className="seemless-textfield1"
                      InputLabelProps={{ shrink: true }}
                      error={this.state.messageError}
                    />
                    {this.state.messageError ? (
                      <Typography className="error-message" variant="body2">
                        *Please enter your message
                      </Typography>
                    ) : (
                      ""
                    )}
                    {/* <br /> */}
                    <Typography
                      id="display"
                      variant="body2"
                      color="error"
                      align="center"
                    >
                      {this.state.error}
                    </Typography>
                    <br />
                    <Button
                      className="sign-up-btn center"
                      id="feedbackButton"
                      size="large"
                      variant="contained"
                      onClick={this.handleSubmit}
                    >
                      Send
                    </Button>
                  </form>
                </Grid>
                <Grid item xs={12} md=  {5} id="thankYou" className="thank-you">
                  {this.thankYou()}
                </Grid>
              </Grid>
            </div>
          </div>
        </div>
      </MuiThemeProvider>
    );
  }
}

export default LandingPage;
